export { default } from './LayoutHome';
